import { Helmet } from 'react-helmet';

const SeoHelmet = ({ title, description, image, url }) => (
  <Helmet>
    {/* Page Title */}
    <title>{title}</title>

    {/* Open Graph Tags */}
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:image" content={image} />
    <meta property="og:url" content={url} />
    <meta property="og:type" content="website" />

    {/* Twitter Card Tags */}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />
    <meta name="twitter:image" content={image} />
  </Helmet>
);

export default SeoHelmet;
